module.exports = __webpack_public_path__ + "static/media/sent.340124a5.svg";